import { omit } from '@yp/common/identity.ts';

// prettier-ignore
export const ReservedTokenNames = [
  'acr', 'amr', 'at_hash', 'aud', 'auth_time', 'azp', 'cnf', 'c_hash', 'exp', 'firebase',
  'iat', 'iss', 'jti', 'name', 'nbf', 'nonce', 'phone_number', 'sub', 'uid', 'user_id'
] as const;

type ReservedTokenName = (typeof ReservedTokenNames)[number];

export function customClaims<T extends Record<string, unknown>>(
  decodedToken: T,
): Omit<T, ReservedTokenName> {
  return omit(decodedToken, ...ReservedTokenNames);
}
